export default {
  container: {
    textAlign: 'center',
  },
};



// WEBPACK FOOTER //
// ./src/components/Landing/styles.js